export enum Role {
  Admin = '1',
  POApproval = '2',
  Financer ='3',
  POCreator ='4',
  TeamMember ='5',
  POreviewer ='6',
  POApprovalLevel1 ='7',
  
}